import { RefObject, useCallback } from "react";
import { useEnclosingJumpMarkSection } from "src/components-mui/common/jump-marks/jump-mark-section";
import { useJumpMarksStore } from "src/components-mui/common/jump-marks/jump-marks.context";
import useViewportSpy from "src/hooks/dom/use-viewport-spy";

interface IUseIsSectionInViewParams<T extends HTMLElement> {
    sectionRef: RefObject<T>;
    threshold?: IntersectionObserverInit["threshold"];
    visibleOnce?: boolean;
}

export const useIsSectionInView = <T extends HTMLElement>({ sectionRef, threshold = 0, visibleOnce = false }: IUseIsSectionInViewParams<T>) => {
    const store = useJumpMarksStore();
    const section = useEnclosingJumpMarkSection();

    const isJumpingPastSection = useCallback(() => {
        const { jumpTargetId } = store.getState();

        return jumpTargetId !== null && jumpTargetId !== section;
    }, [section, store]);

    const isInsideJumpMarkSection = section !== undefined;

    return useViewportSpy(sectionRef, {
        threshold,
        visibleOnce,
        shouldIgnoreChange: isInsideJumpMarkSection ? isJumpingPastSection : undefined,
        subscribeToRecheck: isInsideJumpMarkSection ? store.subscribeToJumpEnd : undefined,
    });
};
